<template>
  <!--====== Section 4: 제작 프로세스 ======-->
  <div class="appie-how-it-work-area pt-10 pb-100">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="how-it-work-thumb text-center">
            <img src="@/assets/images/how-it-work-thumb.png" alt="">
          </div>
        </div>
        <div class="col-lg-6">
          <div class="appie-how-it-work-content">
            <h2 class="title">AI Studio 제작 프로세스</h2>
            <p>초반에 많이 보여주고, 중간에 많이 고칩니다.</p>
            <div class="row">
              <div class="col-sm-6">
                <div class="how-it-work-box">
                  <span>1</span>
                  <h5 class="title">요구사항 정리<br>(미팅 or 문서)</h5>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="how-it-work-box">
                  <span>2</span>
                  <h5 class="title">AI 기반 구조/화면 초안 제작</h5>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="how-it-work-box">
                  <span>3</span>
                  <h5 class="title">초기 결과물 공유 &<br>방향 확정</h5>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="how-it-work-box">
                  <span>4</span>
                  <h5 class="title">개발 + 반복 수정</h5>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="how-it-work-box">
                  <span>5</span>
                  <h5 class="title">웹 + 앱 동시 완성</h5>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="how-it-work-box">
                  <span>6</span>
                  <h5 class="title">스토어 출시 / 운영 연계</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
